import { FormatDate, FormatDateShort } from "utils/dateUtils";
import { useSelector } from "react-redux";
import { FormatNumber } from "utils/numberUtils";
import { getAllReceivablePlans, selectState } from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";

const PrintReceivablesPlan = () => {
  const { partners, planReceivables, receivablesPlanAmount } = useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAllReceivablePlans());
  }, [partners]);

  return (
    <>
      <div className="partners-payables-print">
        <div className="payables-header">PLAN NAPLATE</div>
        <div className="payables-date">
          {FormatDate(new Date().toISOString())}
        </div>
        <div className="payables-list">
          {planReceivables.map((plan, index) => {
            return (
              <div className="single-payable" key={index}>
                <div className="top">
                  <div className="name">
                    <label>{plan.partnerName}</label>
                    <label>
                      {plan.receivablesTotalOutstandingAmount &&
                        FormatNumber(plan.receivablesTotalOutstandingAmount)}
                    </label>
                  </div>
                  <div className="amount">
                    <label>
                      {plan.receivablesPlanAmount &&
                        FormatNumber(plan.receivablesPlanAmount)}
                    </label>
                  </div>
                </div>
                <div className="bot">
                  {plan.plannedReceivables &&
                    plan.plannedReceivables.map((pay, subIndex) => {
                      return (
                        <div className="bot-row" key={subIndex}>
                          <div>{FormatDateShort(pay.dueDate)}</div>
                          <div>{FormatNumber(pay.outstandingAmount)}</div>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
        <div className="payables-total">
          <span>
            <label>ukupno</label>
            <label>{FormatNumber(receivablesPlanAmount || 0)}</label>
          </span>
        </div>
      </div>
    </>
  );
};

export default PrintReceivablesPlan;
